export default __webpack_public_path__ + "static/bluescope_header-d756aed447d9a56df6912c9ba3dd2517.png";